import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import APIEndPoints from '../middleware/APIEndPoints'; 

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { dispatch, error } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState(null); // New state for error message

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });

    console.log(APIEndPoints.sign_in.url);

    try {
      const res = await axios.post(APIEndPoints.sign_in.url, { username, password });
      console.log(res.data)
      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
      
      navigate('/admin-abhijan-home'); // Redirect to admin home
    } catch (err) { 
      const errorResponse = err.response?.data?.message || "Login failed"; // Accessing the error message
      dispatch({ type: "LOGIN_FAILURE", payload: errorResponse });
      setErrorMessage(errorResponse);    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-[#1d0c39]">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="sidebar mt-[-8rem] border-accent border-4 shadow-2xl shadow-white rounded-lg p-8 max-w-sm w-full"
      >
        <motion.h2
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-3xl font-bold text-center text-white mb-6"
        >
          Admin Login
        </motion.h2>

        <form onSubmit={handleLogin} className="space-y-6">
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <label
              htmlFor="username"
              className="block text-xl font-medium text-black"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent transition text-black"
              required
            />
          </motion.div>

          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <label
              htmlFor="password"
              className="block text-xl font-medium text-black"
            >
              Password
            </label>
            <input
              type="text"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent transition text-black"
              required
            />
          </motion.div>

          {error && <span className="text-red-500">{error}</span>}

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <button
              type="submit"
              className="w-full py-2 bg-[#1d0c39] text-white rounded-lg"
            >
              Login
            </button>
          </motion.div>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
